function Footer() {
	return (
		<footer className="bg-gray-800 text-amber-300 pt-6 mt-10">
			<div className="flex justify-between flex-wrap px-6">
				<div>
					<h2 className="text-xl font-bold">Telemix Company Limited</h2>
					<p>Empowering businesses with ICT and infrastructure excellence.</p>
				</div>
				<div>
					<h3 className="font-semibold">Quick Links</h3>
					<ul>
						<li>
							<a href="/services" className="hover:text-yellow-400">
								Services
							</a>
						</li>
						<li>
							<a href="/projects" className="hover:text-yellow-400">
								Projects
							</a>
						</li>
						<li>
							<a href="/contact" className="hover:text-yellow-400">
								Contact
							</a>
						</li>
					</ul>
				</div>
				<div>
					<h3 className="font-semibold">Contact</h3>
					<p>Email: info@telemix.com</p>
					<p>Phone: +234-800-123-4567</p>
				</div>
			</div>
			<p className="text-center bg-gray-900 bg-opacity-40 mt-5 py-8 text-sm text-amber-700">
				&copy; 2025 Telemix Company Limited. All rights reserved.
			</p>
		</footer>
	);
}

export default Footer;
